var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3572",
  "data-name": "Group 3572",
  transform: "translate(-642 -178)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3571",
  "data-name": "Group 3571",
  transform: "translate(640.5 176.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M14.773,7.8A6.523,6.523,0,1,0,21.3,14.323,6.51,6.51,0,0,0,14.773,7.8Zm0,10.938a4.516,4.516,0,1,1,4.516-4.516A4.5,4.5,0,0,1,14.773,18.738Z",
  transform: "translate(-3.273 -3.054)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M17.273,4.282a.73.73,0,0,0,.773-.773V2.273a.773.773,0,1,0-1.545,0V3.509A.774.774,0,0,0,17.273,4.282Z",
  transform: "translate(-5.773)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M6.931,8.013a.747.747,0,0,0,1.082,0,.747.747,0,0,0,0-1.082l-.85-.85A.765.765,0,0,0,6.081,7.163Z",
  transform: "translate(-2.109 -2.109)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M4.282,17.273a.73.73,0,0,0-.773-.773H2.273a.773.773,0,1,0,0,1.545H3.509A.774.774,0,0,0,4.282,17.273Z",
  transform: "translate(0 -5.773)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M6.931,25.732l-.85.85a.747.747,0,0,0,0,1.082.835.835,0,0,0,.541.232.835.835,0,0,0,.541-.232l.85-.85a.765.765,0,0,0-1.082-1.082Z",
  transform: "translate(-2.109 -8.636)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M17.273,29.1a.73.73,0,0,0-.773.773v1.236a.773.773,0,1,0,1.545,0V29.872A.774.774,0,0,0,17.273,29.1Z",
  transform: "translate(-5.773 -10.381)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M26.814,25.732a.765.765,0,0,0-1.082,1.082l.85.85a.747.747,0,0,0,1.082,0,.747.747,0,0,0,0-1.082Z",
  transform: "translate(-8.636 -8.636)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M31.109,16.5H29.872a.773.773,0,0,0,0,1.545h1.236a.773.773,0,1,0,0-1.545Z",
  transform: "translate(-10.381 -5.773)",
  fill: "#f3705a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M26.273,8.245a.7.7,0,0,0,.541-.232l.85-.85a.765.765,0,0,0-1.082-1.082l-.85.85a.747.747,0,0,0,0,1.082A.7.7,0,0,0,26.273,8.245Z",
  transform: "translate(-8.636 -2.109)",
  fill: "#f3705a"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(646 182)",
  fill: "#f3705a"
}))));
export default __webpack_public_path__ + "static/media/everGreen.c9ed4347.svg";
export { SvgComponent as ReactComponent };